module.exports = __webpack_public_path__ + "static/media/news-7.5ca7b2d5.jpg";